import React from 'react';

import './backlog.scss';

import { EmptyPage } from '../empty-page/EmptyPage';

export const Backlog = () => {
  return <EmptyPage />;
};
